import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgThreadsIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 56 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M28.491 64h-.02c-9.515-.064-16.831-3.213-21.749-9.357C2.353 49.171.096 41.562.02 32.026v-.045c.077-9.543 2.334-17.146 6.71-22.618C11.64 3.213 18.962.064 28.472 0h.039c7.296.051 13.4 1.933 18.139 5.594 4.458 3.443 7.596 8.345 9.324 14.579l-5.421 1.517C47.619 11.13 40.195 5.734 28.485 5.65c-7.73.058-13.58 2.496-17.38 7.245C7.551 17.344 5.714 23.77 5.644 32c.07 8.23 1.907 14.656 5.466 19.104 3.801 4.755 9.65 7.194 17.38 7.245 6.971-.051 11.583-1.683 15.416-5.453 4.375-4.3 4.299-9.58 2.896-12.794-.823-1.894-2.322-3.468-4.344-4.665-.51 3.603-1.652 6.521-3.412 8.723-2.354 2.938-5.69 4.544-9.912 4.774-3.195.173-6.276-.582-8.661-2.137-2.826-1.837-4.478-4.64-4.656-7.904-.172-3.175 1.084-6.093 3.533-8.218 2.34-2.029 5.632-3.219 9.523-3.443 2.864-.16 5.549-.032 8.023.378-.331-1.978-.995-3.552-1.99-4.685-1.364-1.562-3.476-2.355-6.27-2.375h-.076c-2.245 0-5.294.621-7.233 3.52l-4.668-3.142c2.602-3.878 6.824-6.016 11.901-6.016h.115c8.49.051 13.547 5.267 14.051 14.368.287.122.574.25.855.378 3.96 1.868 6.856 4.697 8.38 8.185 2.118 4.858 2.316 12.775-4.113 19.091C42.93 61.76 36.968 63.942 28.51 64h-.019Zm2.666-31.174c-.644 0-1.295.019-1.964.057-4.88.275-7.922 2.522-7.75 5.715.179 3.348 3.859 4.903 7.399 4.71 3.253-.172 7.488-1.446 8.202-9.894-1.798-.39-3.77-.588-5.887-.588Z"
      fill="currentColor"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgThreadsStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgThreadsIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const ThreadsIcon: any = SvgThreadsStyle;
export default ThreadsIcon;
